import { Injectable } from '@angular/core';
import { AngularFire, AuthProviders, AuthMethods } from 'angularfire2';
import * as firebase from 'firebase';

@Injectable()

export class AuthData {
  fireAuth: any;

  constructor(public af: AngularFire) {
     af.auth.subscribe( user => {
       if (user) {
         this.fireAuth = user.auth;
       }
    });
  }

  getUser() {
    return this.fireAuth;
  }

  verifyEmail() {
    firebase.auth().currentUser.sendEmailVerification().then(res => {
      console.log('Correo envíado', res);
    }).catch(err => {
      console.log('Error enviando correo', err);
    });
  }

  getUserdb(email){
    return this.af.database.list('/Users', {
     query:{
       orderByChild:'email',
       equalTo: email
     }
   });
  }

  getExactUser(uid) {
    return firebase.database().ref(`/Clients/rebus/Users/${uid}`);
  }

  loginFacebook() {
    var provider = new firebase.auth.FacebookAuthProvider();
	  provider.addScope('email');
    provider.addScope('public_profile');
    provider.addScope('user_birthday');

    return firebase.auth().signInWithPopup(provider);
  }

  loginGoogle() {
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('email');
    provider.addScope('profile');

    return firebase.auth().signInWithPopup(provider);
  }

  loginTwitter() {
    var provider = new firebase.auth.TwitterAuthProvider();

    return firebase.auth().signInWithPopup(provider);
  }

  loginUser(newEmail: string, newPassword: string): any {
   return this.af.auth.login({ email: newEmail, password: newPassword });
  }

  anonymousLogin(): any {
    return this.af.auth.login({
      provider: AuthProviders.Anonymous,
      method: AuthMethods.Anonymous,
    });
  }

  linkAccount(email, password): any {
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);

    return this.fireAuth.link(credential);
  }

  resetPassword(email: string): any {
    return firebase.auth().sendPasswordResetEmail(email);
  }

  logoutUser(): any {
    return firebase.auth().signOut();
  }

  saveGcm(gcmId): any {
    if (gcmId) {
      // TODO: device information
      firebase.database().ref('___gcmDevices/' + this.getUser().uid).set({
        gcmId: gcmId,
        state: true
      });
    }
  }
}
// TODO: Add scope for social login functions
// end file



// WEBPACK FOOTER //
// ./src/providers/auth.ts